import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

// App
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { AppRoutes } from './app.routes';

// Pages
import { FaqPageComponent } from './pages/study-container-page/faq-page/faq-page.component';
import { OrganizationListPageComponent } from './pages/study-container-page/organization-list-page/organization-list-page.component';
import { PageNotFoundPageComponent } from './pages/page-not-found-page/page-not-found-page.component';
import { StudyContainerPageComponent } from './pages/study-container-page/study-container-page.component'
import { StudyLandingPageComponent } from './pages/study-container-page/study-landing-page/study-landing-page.component'
import { StudyPageComponent } from './pages/study-container-page/study-page/study-page.component'
import { SurveyGizmoPageComponent } from './pages/study-container-page/survey-gizmo-page/survey-gizmo-page.component';
import { ThankYouPageComponent } from './pages/thank-you-page/thank-you-page.component';

// Partials
import { EmbeddedHtmlComponent } from './partials/embedded-html/embedded-html.component';
import { ExpandableBlockComponent } from './partials/expandable-block/expandable-block.component';
import { LanguageSelectorComponent } from './partials/language-selector/language-selector.component';
import { OrganizationSelectionFormComponent } from './partials/organization-selection-form/organization-selection-form.component';
import { OrganizationSelectionRowComponent } from './partials/organization-selection-row/organization-selection-row.component';
import { PhotoWithCredit } from './partials/photo-with-credit/photo-with-credit.component';
import { StudyFooterComponent } from './partials/study-footer/study-footer.component';

// Pipes
import { SafeHttpPipe } from './pipes/safe-http.pipe';

// Services
import { AjaxService } from './services/ajax.service';
import { EnvironmentService } from './services/environment.service';
import { OrganizationRequestService } from './services/organization-request.service';
import { StudyContainerPageService } from './pages/study-container-page/study-container-page.service';
import { StudyImageRequestService } from './services/study-image-request.service';
import { StudyRequestService } from './services/study-request.service';
import { ActiveLanguageService } from './services/active-language.service';
import { CookieService } from 'ngx-cookie-service';

// Utility
import { setAppInjector } from './utility/app-injector';

@NgModule({
    declarations: [
        // App
        AppComponent,

        // Pages
        FaqPageComponent,
        OrganizationListPageComponent,
        PageNotFoundPageComponent,
        StudyContainerPageComponent,
        StudyLandingPageComponent,
        StudyPageComponent,
        SurveyGizmoPageComponent,

        // Partials
        EmbeddedHtmlComponent,
        ExpandableBlockComponent,
        LanguageSelectorComponent,
        OrganizationSelectionFormComponent,
        OrganizationSelectionRowComponent,
        PhotoWithCredit,
        StudyFooterComponent,
        ThankYouPageComponent,

        // Pipes
        SafeHttpPipe,
    ],
    imports: [
        AppRoutes,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        NgbModule.forRoot(),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        AjaxService,
        AppConfig,
        EnvironmentService,
        OrganizationRequestService,
        StudyContainerPageService,
        StudyImageRequestService,
        StudyRequestService,
        ActiveLanguageService,
        CookieService,
        { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
    constructor(injector: Injector) {
        setAppInjector(injector);
    }
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts